import { z } from "zod";

export const SnapshotSummarySchema = z
  .object({
    id: z.string().nanoid(),
    label: z.string(),
    createdAt: z.coerce.date(),
    fileCount: z.number().int(),
    lamportId: z.number().int(),
  })
  .describe("Summary information for a filesystem snapshot");
export type SnapshotSummary = z.infer<typeof SnapshotSummarySchema>;

export const SnapshotFileSchema = z
  .object({
    path: z.string(),
    content: z.string(),
  })
  .describe("A file contained within a filesystem snapshot");
export type SnapshotFile = z.infer<typeof SnapshotFileSchema>;

export const SnapshotSchema = z
  .object({
    id: z.string().nanoid(),
    label: z.string(),
    createdAt: z.coerce.date(),
    files: SnapshotFileSchema.array(),
    lamportId: z.number().int(),
  })
  .describe("A filesystem snapshot containing files");
export type Snapshot = z.infer<typeof SnapshotSchema>;

// Event Payload Schemas (for WebSocket events - use string dates for serialization)
export const FpFilesystemSnapshotSummarySchema = z.object({
  id: z.string(),
  label: z.string(),
  createdAt: z.string(),
  fileCount: z.number().int(),
  lamportId: z.number().int(),
});
export type FpFilesystemSnapshotSummary = z.infer<
  typeof FpFilesystemSnapshotSummarySchema
>;

export const FpFilesystemFileSchema = z.object({
  path: z.string(),
  content: z.string(),
});
export type FpFilesystemFile = z.infer<typeof FpFilesystemFileSchema>;

export const FpFilesystemSnapshotSchema = z.object({
  id: z.string(),
  label: z.string(),
  createdAt: z.string(),
  files: z.array(FpFilesystemFileSchema),
  lamportId: z.number().int(),
});
export type FpFilesystemSnapshot = z.infer<typeof FpFilesystemSnapshotSchema>;

// Filesystem Snapshot Events
export const FpFilesystemSnapshotsUpdatedSchema = z.object({
  type: z.literal("filesystem.snapshots.updated"),
  snapshots: z.array(FpFilesystemSnapshotSummarySchema),
});
export type FpFilesystemSnapshotsUpdated = z.infer<
  typeof FpFilesystemSnapshotsUpdatedSchema
>;

export function createFilesystemSnapshotsUpdated(
  snapshots: Array<FpFilesystemSnapshotSummary>,
): FpFilesystemSnapshotsUpdated {
  return {
    type: "filesystem.snapshots.updated",
    snapshots,
  };
}

export const FpFilesystemSnapshotCreatedSchema = z.object({
  type: z.literal("filesystem.snapshot.created"),
  snapshot: FpFilesystemSnapshotSchema,
});
export type FpFilesystemSnapshotCreated = z.infer<
  typeof FpFilesystemSnapshotCreatedSchema
>;

export function createFilesystemSnapshotCreated(
  snapshot: FpFilesystemSnapshot,
): FpFilesystemSnapshotCreated {
  return {
    type: "filesystem.snapshot.created",
    snapshot,
  };
}
